import {
  AccountSummary,
  DrawerHeaderProps,
  DrawerHeaderRef,
  Selectors,
  openURL,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useSelector} from 'Provider';
import {View} from 'native-base';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Platform} from 'react-native';

import {StyledScrollView} from 'components/Styled';
import ConnectedDrawerHeader from 'containers/NavigationDrawer/DrawerHeader';
import {NavItems} from 'models/AuthenticatedNavItems';
import {LinkData} from 'models/Navigation';
import {navigationLinksSelector} from 'store/content';
import {getLinkData, navigateOrOpenUrl} from 'utils/navigation';
import {getSigninUrl, navigateToSignin} from 'utils/signin';

export interface NavigationDrawerProps
  extends Omit<DrawerHeaderProps, 'svgLogo'> {
  onOpen?: (isOpen: boolean) => void;
}

const NavigationDrawer: React.FC<NavigationDrawerProps> = ({onOpen}) => {
  const [isOpen, setOpen] = useState(false);
  const drawerRef = useRef<DrawerHeaderRef>(null);
  const handleToggle = shouldOpen => {
    setOpen(shouldOpen);
  };

  useEffect(() => onOpen && onOpen(isOpen), [onOpen, isOpen]);

  const closeDrawer = () => {
    drawerRef && drawerRef.current?.toggle();
  };
  const isLoggedIn = useWidgetState(Selectors.isLoggedInSelector) as boolean;
  const links = useSelector(navigationLinksSelector);

  const formattedLinks = useMemo(() => {
    const baseLinks = isLoggedIn ? NavItems : links;
    return baseLinks.map(navItem => getLinkData(navItem.title, navItem.url));
  }, [isLoggedIn, links]);

  const handleLogin = () => {
    if (!window.isLegacyMyRewards) {
      const forwardUrl =
        Platform.OS === 'web' ? window.location.pathname : undefined;
      const params = forwardUrl
        ? `forwardUrl=${encodeURIComponent(forwardUrl)}`
        : undefined;
      navigateToSignin(params);
    } else {
      openURL('/myrewards/profile');
    }
  };

  const handleCRMenuLinkPress = (link?: LinkData) => {
    if (link) {
      const {newRewardsScreen, url} = link;
      navigateOrOpenUrl({legacyUrl: url, newRewardsScreen});
    }
  };

  return (
    <View
      height={isOpen ? '100%' : '41px'}
      position={isOpen && !window.isLegacyMyRewards ? 'absolute' : 'relative'}
      width="100%">
      <ConnectedDrawerHeader ref={drawerRef} onToggle={handleToggle} />
      {isOpen && (
        <StyledScrollView
          backgroundColor="white"
          height="100%"
          testID="my-rewards-mobile-menu-modal">
          <AccountSummary
            href={
              window.isLegacyMyRewards
                ? '/myrewards/profile/signin'
                : getSigninUrl()
            }
            crMenuLinks={formattedLinks}
            isAuthenticated={isLoggedIn}
            onClose={closeDrawer}
            onPress={handleLogin}
            onCRMenuLinkPress={handleCRMenuLinkPress}
          />
        </StyledScrollView>
      )}
    </View>
  );
};

export default NavigationDrawer;
